var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        staticClass: "col-12 mt-2 mb-2 pl-0",
        attrs: { "has-line": false, title: "Información General" }
      }),
      _c("div", { staticClass: "row mb-4 pl-3" }, [
        _c(
          "div",
          { staticClass: "col-sm" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-input", {
                        attrs: {
                          "custom-error-msg": errors[0],
                          error: errors[0],
                          label: "Número de RUP:",
                          type: "number"
                        },
                        model: {
                          value: _vm.data.rupNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "rupNumber", $$v)
                          },
                          expression: "data.rupNumber"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-sm" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-input", {
                        attrs: {
                          "custom-error-msg": _vm.validationMessages.required,
                          error: errors[0],
                          label: "Teléfono:",
                          "mask-type": "Phone",
                          placeholder: "(___) ___-____"
                        },
                        model: {
                          value: _vm.data.phoneNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "phoneNumber", $$v)
                          },
                          expression: "data.phoneNumber"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-sm" },
          [
            _c("custom-input", {
              attrs: {
                label: "Fax:",
                "mask-type": "Phone",
                placeholder: "(___) ___-____"
              },
              model: {
                value: _vm.data.faxNumber,
                callback: function($$v) {
                  _vm.$set(_vm.data, "faxNumber", $$v)
                },
                expression: "data.faxNumber"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-sm" },
          [
            _c("custom-input", {
              attrs: {
                label: "Dirección Web:",
                placeholder: "www.websitedomain.com"
              },
              model: {
                value: _vm.data.website,
                callback: function($$v) {
                  _vm.$set(_vm.data, "website", $$v)
                },
                expression: "data.website"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-sm" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-input", {
                        attrs: {
                          "custom-error-msg": errors[0],
                          error: errors[0],
                          label: "Registro del Departamento de Estado:",
                          type: "number"
                        },
                        model: {
                          value: _vm.data.stateDeptRegistration,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "stateDeptRegistration", $$v)
                          },
                          expression: "data.stateDeptRegistration"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-sm" },
          [
            _c("custom-input", {
              attrs: { label: "Supplier Site:", maxlength: "10" },
              model: {
                value: _vm.data.supplierSite,
                callback: function($$v) {
                  _vm.$set(_vm.data, "supplierSite", $$v)
                },
                expression: "data.supplierSite"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row align-items-center mb-4 pl-3" }, [
        !_vm.isIndividualCompany
          ? _c(
              "div",
              { staticClass: "col-xm" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-radio", {
                              attrs: {
                                "custom-error-msg": "Este campo es requerido",
                                error: errors[0],
                                "is-inline": "",
                                label: "Tipo de Proveedor:",
                                name: "profitType",
                                options: _vm.profitTypeOptions
                              },
                              on: { input: _vm.resetLegalSuffixes },
                              model: {
                                value: _vm.data.profitType,
                                callback: function($$v) {
                                  _vm.$set(_vm.data, "profitType", $$v)
                                },
                                expression: "data.profitType"
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    2512665793
                  )
                })
              ],
              1
            )
          : _vm._e(),
        _vm.data.profitType == 1
          ? _c(
              "div",
              { staticClass: "col-xm" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-drop-down", {
                              attrs: {
                                clearable: false,
                                error: errors[0],
                                fieldkey: "id",
                                fieldname: "name",
                                label: "Designación Corporativa:",
                                options: _vm.legalsuffixes
                              },
                              model: {
                                value: _vm.data.legalSuffix,
                                callback: function($$v) {
                                  _vm.$set(_vm.data, "legalSuffix", $$v)
                                },
                                expression: "data.legalSuffix"
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    961657857
                  )
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm.isIndividualCompany
        ? _c("div", { staticClass: "row mb-4 pl-3" }, [
            _c(
              "div",
              { staticClass: "col-md-4" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-input", {
                              attrs: {
                                "custom-error-msg": errors[0],
                                error: errors[0],
                                label: "Especialidad:",
                                maxlength: "100"
                              },
                              model: {
                                value: _vm.data.specialty,
                                callback: function($$v) {
                                  _vm.$set(_vm.data, "specialty", $$v)
                                },
                                expression: "data.specialty"
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3602135033
                  )
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-4" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-input", {
                              attrs: {
                                "custom-error-msg": errors[0],
                                error: errors[0],
                                label: "Número de Licencia:",
                                maxlength: "50"
                              },
                              model: {
                                value: _vm.data.licenseNumber,
                                callback: function($$v) {
                                  _vm.$set(_vm.data, "licenseNumber", $$v)
                                },
                                expression: "data.licenseNumber"
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3133113267
                  )
                })
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }